module.exports = __webpack_public_path__ + "img/notification-box.d055c389.svg";